import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { IDepositionState, depositionTypes } from './types';
import * as depositionAction from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: IDepositionState = {
  depositionFiles: {
    exhibit: [],
    final: [],
    production: [],
  },
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: IDepositionState, payload: UnsafeReturnType<T>): IDepositionState;
}

const setDepositionExhibit: IActionHandler<typeof depositionAction['setDepositionExhibit']> = (state, { payload }) => ({
  ...state,
  depositionFiles: {
    ...state.depositionFiles,
    exhibit: payload ?? [],
  },
});

const setDepositionFinal: IActionHandler<typeof depositionAction['setDepositionFinal']> = (state, { payload }) => ({
  ...state,
  depositionFiles: {
    ...state.depositionFiles,
    final: payload ?? [],
  },
});

const setDepositionProduction: IActionHandler<typeof depositionAction['setDepositionProduction']> = (
  state,
  { payload },
) => ({
  ...state,
  depositionFiles: {
    ...state.depositionFiles,
    production: payload ?? [],
  },
});

const resetDepositionFiles: IActionHandler<typeof depositionAction['resetDepositionFiles']> = state => ({
  ...state,
  depositionFiles: {
    exhibit: [],
    final: [],
    production: [],
  },
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [depositionTypes.SET_DEPOSITION_EXHIBIT]: setDepositionExhibit,
  [depositionTypes.SET_DEPOSITION_FINAL]: setDepositionFinal,
  [depositionTypes.SET_DEPOSITION_PRODUCTION]: setDepositionProduction,
  [depositionTypes.RESET_FILES]: resetDepositionFiles,
};

const depositionReducer = createReducer<IDepositionState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export { depositionReducer, depositionTypes, depositionAction };
